import { render, staticRenderFns } from "./ProjectMenu.vue?vue&type=template&id=502fa573&"
import script from "./ProjectMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports